











































































































































import { AtendimentoService, Consultor } from "@/services/atendimento.service";
import { Component, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { cpf, date, dateTime, telefone } from "@/shared/filters";
import EditarObservacao from "../modals/EditarObservacao.vue";

@Component({
  components: {
    EditarObservacao,
  },
  filters: { cpf, date, dateTime, telefone },
})
export default class DadosConsultor extends mixins(GlobalMixin) {
  @Prop() idConsultor!: number;
  consultor: Consultor | null = null;
  loading = false;

  get catalogos() {
    if (this.consultor?.listaCatalogos.length ?? 0 > 0)
      return this.consultor?.listaCatalogos?.map((x) => x.nome)?.join(", ");
    else return "";
  }

  mounted() {
    this.fetchConsultoresSelecionado(this.idConsultor);
  }

  async fetchConsultoresSelecionado(idConsultor: number) {
    this.loading = true;
    try {
      this.consultor = await AtendimentoService.ObterDadosConsultor(
        idConsultor
      );
    } finally {
      this.loading = false;
    }
  }

  public atualizarConsultorSelecionado() {
    this.fetchConsultoresSelecionado(this.idConsultor);
  }

  trocarConsultor() {
    this.$router.push({
      name: "home",
    });
  }

  async editarObservacao() {
    const modal = this.$refs.editarObservacao as EditarObservacao;
    await modal.abrirModalObservacao(this.consultor!.observacao);
    this.fetchConsultoresSelecionado(this.idConsultor);
  }
}
